import { Scale, ShieldAlert, Landmark, HandCoins } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/motion/Reveal";

const SERVICES = [
  {
    icon: Scale,
    title: "Diritto Civile e Contrattualistica",
    desc: "Redazione, revisione e gestione di contratti per la fornitura di beni e servizi, garantendo la massima tutela degli interessi commerciali di aziende e privati.",
  },
  {
    icon: ShieldAlert,
    title: "Infortunistica e Risarcimento Danni",
    desc: "Tutela dei diritti in caso di sinistri stradali, infortuni sul lavoro o responsabilità professionale, finalizzata all'ottenimento del giusto risarcimento.",
  },
  {
    icon: Landmark,
    title: "Diritto Tributario",
    desc: "Assistenza nei rapporti con l'Amministrazione Finanziaria, gestione del contenzioso tributario e difesa del contribuente di fronte ad accertamenti e cartelle esattoriali.",
  },
  {
    icon: HandCoins,
    title: "Recupero Crediti e Garanzie",
    desc: "Gestione efficiente delle procedure di recupero crediti, con specifica competenza nelle vendite garantite da ipoteca o pegno, ottimizzando i tempi di realizzo e la tutela del patrimonio creditorio.",
  },
];

const Services = () => (
  <section id="aree-attivita" className="bg-navy-texture py-24 sm:py-32" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHeading
        index="02"
        eyebrow="Aree di Attività"
        title="Aree di Specializzazione"
        subtitle="Consulenza ed assistenza legale mirata, giudiziale e stragiudiziale."
        dark
      />

      <div className="mt-16 grid gap-6 md:grid-cols-2">
        {SERVICES.map((s, i) => (
          <Reveal key={s.title} delay={i * 0.1}>
            <article
              data-testid={`service-card-${i + 1}`}
              className="group relative h-full border border-white/10 bg-white/[0.04] p-8 sm:p-10 backdrop-blur-sm transition-all duration-500 hover:border-gold/50 hover:bg-white/[0.07]"
            >
              <span className="absolute right-7 top-6 font-serif text-5xl text-white/[0.06] transition-colors duration-500 group-hover:text-gold/20">
                0{i + 1}
              </span>
              <span className="flex h-12 w-12 items-center justify-center border border-gold/40 bg-gold/10 text-gold transition-transform duration-500 group-hover:scale-110">
                <s.icon className="h-6 w-6" />
              </span>
              <h3 className="mt-7 font-serif text-xl sm:text-2xl text-white">{s.title}</h3>
              <p className="mt-4 text-sm sm:text-base leading-relaxed text-slate-300">{s.desc}</p>
              <span className="mt-7 block h-px w-10 bg-gold/50 transition-all duration-500 group-hover:w-full group-hover:bg-gold/70" />
            </article>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
